module.exports = __webpack_public_path__ + "img/es-AR.91013f67.svg";